/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2023-01-10 19:12:45
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-02 15:05:34
 */
import ColumnTypes from '@/utils/ColumnTypes';
const goodsInfo = {
	key: 'goodsInfo',
	label: '商品信息',
	type: () => import('./tableCells/goodsBoxCell.vue'),
	minwidth: '260',
};
const chooseSku = {
	key: 'chooseSku',
	label: '选择寄样规格',
	type: () => import('./tableCells/chooseSkuCell.vue'),
	width: '120',
};
const specification = {
	key: 'specification',
	renderHeader: h => h('span', {}, [h('i', { class: 'redStar' }, ''), '已选规格']),
	type: () => import('./tableCells/specificationCell.vue'),
	width: '200',
};
const price = {
	key: 'price',
	label: '直播价',
	type: ColumnTypes.PriceCell,
	width: '80',
};
const numbs = {
	key: 'nums',
	label: '申样数量',
	type: () => import('./tableCells/numbsCell.vue'),
	width: '120',
};
const specificationRemark = {
	key: 'specificationRemark',
	label: '规格备注',
	type: ColumnTypes.remarkCell,
	width: '100',
};
export const operations = {
	key: 'operations',
	label: '操作',
	type: ColumnTypes.ButtonsCell,
	width: '80',
};
export default [goodsInfo, chooseSku, specification, price, numbs, specificationRemark];
